import { CircularProgress, Dialog, DialogContent, Stack, Typography } from '@mui/material';

interface Props {
  open: boolean;
}

const SaveDialog = ({ open }: Props) => {
  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogContent>
        <Stack gap={2} alignItems="center" px={2} py={5}>
          <CircularProgress />
          <Typography variant="body2">The information is being saved</Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default SaveDialog;
